import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login.vue'
import History from '@/views/History.vue'
import HistoryListTab from '@/views/History/ListTab.vue'
import HistoryScanTab from '@/views/History/ScanTab.vue'
import HistorySavingsTab from '@/views/History/SavingsTab.vue'

// store
import store from '@/store/store'

Vue.use( Router  )

const router = new Router( {
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'login',
			component: Login,
			meta: {
			}
		},
		{
			path: '/history',
			name: 'history',
			component: History,
			meta: {
				requiresAuth: true
			},
			children: [
				{
					path: 'list',
					name: 'historylisttab',
					component: HistoryListTab
				},
				{
					path: 'scan',
					name: 'historyscantab',
					component: HistoryScanTab
				},
				{
					path: 'savings',
					name: 'historysavingstab',
					component: HistorySavingsTab
				}
			]
		}
	]
} );

router.beforeEach( ( to, from, next ) => {

	const requiresAuth = to.matched.some( record => record.meta.requiresAuth );
	const guest = to.matched.some( record => record.meta.guest );

	// needs to be logged in
	if ( requiresAuth ) {
		// check if logged in, if not kick to login page
		if ( store.state.patron.loggedIn ) {
			// logged in
			next( );
		} else {
			// not logged in
			next( '/' );
		}
	}
	// needs to not be logged in
	if ( guest ) {
		// check if logged in, if so kick to account page
		if ( store.state.patron.loggedIn ) {
			// logged in
			next( '/history/scan' );
		} else {
			// not logged in
			next( );
		}
	}

	next( );
} );

export default router